import React from "react";
import { Circles } from "../components";

const CirclesContainer: React.FC = () => (
  <Circles>
    <Circles.Circle1 />
    <Circles.Circle2 />
    <Circles.Circle3 />
    <Circles.Circle4 />
  </Circles>
);

export default CirclesContainer;
